import { uniqueId } from 'lodash';
import { Section } from './Book';
import { Temp } from './Temp';

export default class Subchapter {
  id!: number;
  chapterId!: number;
  title: string = '';
  order!: number;
  sections?: Section[];

  constructor(subchapter?: Partial<Subchapter>) {
    Object.assign(this, subchapter);
  }
}

export class TempSubChapter extends Subchapter implements Temp {
  tempId?: string = uniqueId();
}
